import queries from '@apis/queries';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';

declare module '@stackflow/config' {
    interface Register {
        EasyCardActivity: {};
    }
}

const EasyCardActivity: ActivityComponentType<'EasyCardActivity'> = () => {
    const a = '';
    useQuery(queries.easyCard.payU());
    return (
        <AppScreen>
            <Header title='간편카드' />
        </AppScreen>
    );
};

export default EasyCardActivity;
